import React, { useEffect, useState } from "react";
import TransactionLoader from "../../../../loader/TransactionLoader";
import { Dropdown } from "react-materialize";
import { Area, ComposedChart, ResponsiveContainer, XAxis ,Tooltip} from "recharts";
import { handleDateSetUp } from "../../../../../helpers/helpers";

function AmountDebitedChart({ loadings, debitRecord }) {
  const [number, setNumber] = useState(3);
  const [debitAmount, setDebitAmount] = useState([]);

  useEffect(() => {
    const correctDateFormate = debitRecord?.map((item) => ({
      ...item,
      date: handleDateSetUp(item?.date),
    }));
    setDebitAmount(correctDateFormate);
  }, [debitRecord]);

  if (loadings) {
    return <TransactionLoader />;
  }

  return (
    <div
      className="white full-width"
      style={{
        borderRadius: "12px",
        boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
        padding: "10px 10px 0 10px",
      }}
    >
      <div
        className={`
           flex space-between mb-1`}
      >
        <h5 className="margin-0px">Amount Debited</h5>

        <Dropdown
          id="amount-debit-monthsDropdown"
          trigger={
            <div
              className="valign-wrapper align-center cover grey lighten-3 font-cercular-bold black-text"
              style={{ padding: "5px 25px" }}
            >
              <p
                style={{
                  fontSize: "14px",
                }}
              >
                Last {number} Months
              </p>
              <span
                class="material-icons-outlined"
                style={{ marginLeft: "0.5rem" }}
              >
                keyboard_arrow_down
              </span>
            </div>
          }
        >
          <span onClick={() => setNumber(3)}>3 months</span>
          <span onClick={() => setNumber(6)}>6 Months</span>
          <span onClick={() => setNumber(12)}>1 Year</span>
          <span onClick={() => setNumber(24)}>2 Years</span>
        </Dropdown>
      </div>

      <ResponsiveContainer width="100%" height={175}>
        <ComposedChart data={debitAmount}>
          {/* <CartesianGrid verticalPoints={[-1]} /> */}
          <XAxis dataKey="date" />
          {/* <YAxis /> */}
          <Tooltip content={<CustomTooltipDebit />} />
          <Area
            type="monotone"
            dataKey="totalAmount"
            stroke="#008080"
            fillOpacity={1}
            fill="url(#colorPvv)"
          />

          <defs>
            <linearGradient id="colorPvv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#008080" stopOpacity={0.9} />
              <stop offset="95%" stopColor="#008080" stopOpacity={0.4} />
            </linearGradient>
          </defs>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
const CustomTooltipDebit = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="cover valign-wrapper p-1 grey lighten-5" style={{}}>
        <span>
          <p>{`${label}`}</p>
          <p>
            <span className="cyan-text">Debit Amount:</span>
            {` ${payload[0].value}`}
          </p>
        </span>
      </div>
    );
  }
};

export default AmountDebitedChart;
